var React = require('react');

function Pen (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M498 142.08l-56.6 56.55-128-128 56.55-56.55a48 48 0 0 1 67.91 0L498 74.17a48 48 0 0 1 0 67.91z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M12.85 371.11L.15 485.33a24 24 0 0 0 26.49 26.51l114.14-12.6 278-278-128-128z","className":"fa-primary","key":2})]);
}

Pen.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Pen;

Pen.default = Pen;
